(function () {
	const searchModal = () => {
		$(".search__form-inner,.search-mobile-trigger").click(
			function (e) {
				e.preventDefault();
				searchOpen();
			}
		);
		// Delegated click binding — the predictive-search popup re-renders
		// its inner HTML (incl. the close button) on every keystroke via
		// assets/predictive-search.js, so a direct `.click()` binding only
		// catches the original close button and loses the new one each
		// time the popup updates. Delegating from `document` survives any
		// re-render.
		$(document).on(
			"click",
			".search-modal__overlay,.search__close,.search-mobile-close",
			function (e) {
				e.preventDefault();
				searchClose();
			}
		);
		$(document).on("click", ".search-reset__button", function () {
			searchClose();
		});
	};
	$(document).on("keyup", function (e) {
		if (e.key != "Escape") return;
		// A quick-view popup is layered above the search modal. quick-add.js
		// moves it onto <body> (outside .search-modal), so let it handle its
		// own Escape and don't also close the search modal underneath it.
		if ($("quick-add-modal[open]").length) return;
		if ($(".search-modal").hasClass("active")) {
			searchClose();
		}
	});
	$(document).on("click", function (e) {
		var $target = $(e.target);
		// `quick-add-modal` is appended to <body> (outside .search-modal), so a
		// click inside the quick-view popup — its close button, overlay or
		// content — would otherwise read as an "outside" click and close the
		// search modal behind it. Treat the quick-view popup as inside.
		var insideSearch = $target.closest(".search-modal, .search-modal-mobile, .search-mobile-trigger, .search__form-inner, quick-add-modal").length > 0;
		if (($(".search-modal").hasClass("active") || $(".search-modal-mobile").hasClass("active")) && !insideSearch) {
			searchClose();
		}
	});
	// Re-open modal if user starts typing while focus is still on search input
	// Close modal when input is cleared (backspace to empty)
	$(document).on("input", ".search-modal .search__input", function () {
		const $modal = $(this).closest(".search-modal");
		if ($(this).val().trim() === "" && $modal.hasClass("active")) {
			searchClose();
		} else if (!$modal.hasClass("active")) {
			searchOpen();
		}
	});

	function searchOpen() {
		var isMobile = window.innerWidth < 1024;
		if (isMobile) {
			$("#search-modal-mobile").addClass("active");
			$("#search-modal-mobile").find(".search__input")[0].focus();
			// Lock both <html> and <body>: `html { scrollbar-gutter: stable }`
			// makes <html> the viewport scroll container, so overflow:hidden on
			// <body> alone does not stop the page scrolling behind the popup.
			$("html, body").addClass("overflow-hidden");
		} else {
			$("#search-modal").addClass("active");
			$("#search-modal").find(".search__input")[0].focus();
			// Pin header fixed — same mechanism as sticky/white state in base.css
			$(".shopify-section-header").addClass("shopify-section-header-sticky").removeClass("shopify-section-header-hidden");
			// Always lock scroll while the search popup (initial content or
			// results) is open, regardless of the overlay's hide-overlay state.
			// Lock <html> too — `html { scrollbar-gutter: stable }` makes <html>
			// the viewport scroll container, so locking <body> alone is not enough.
			$("html, body").addClass("overflow-hidden");
		}
	}
	function searchClose() {
		$("#search-modal").removeClass("active");
		$("#search-modal-mobile").removeClass("active");
		$(".search-modal-trigger").focus();
		var element = $(".search-modal__form-main");
		if (element.length && element.attr("open") !== undefined) {
			element[0].removeAttribute('open');
		}
		$("html, body").removeClass("overflow-hidden");
		// Let scroll handler recalculate header state now that search is closed
		window.dispatchEvent(new Event('scroll'));
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();